unit UAttachmentModel;

interface

uses
  UEssentialHelper, Js;

type
  TAttachmentModel = class
  private
    FFilename: string;
    FFakNr: string;
    FKind: TAttachmentKind;
    FCreatedAt: TDateTime;
    FTransmittedAt: TDateTime;
    FOnPropertyChanged: TPropertyChangedEvent;
    FName: string;
    FVorname: string;
    FPersonalNr: string;
    FSelected: Boolean;
    procedure ClearValues;
    procedure DoPropertyChanged(PropertyName: string);
    procedure SetValues(Json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetCreatedAt(const Value: TDateTime);
    procedure SetFakNr(const Value: string);
    procedure SetFilename(const Value: string);
    procedure SetKind(const Value: TAttachmentKind);
    procedure SetTransmittedAt(const Value: TDateTime);
    procedure SetOnPropertyChanged(const Value: TPropertyChangedEvent);
    procedure SetName(const Value: string);
    procedure SetVorname(const Value: string);
    procedure SetPersonalNr(const Value: string);
    procedure SetSelected(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    function ToJson: string;
    property FakNr: string read FFakNr write SetFakNr;
    property Filename: string read FFilename write SetFilename;
    property CreatedAt: TDateTime read FCreatedAt write SetCreatedAt;
    property Kind: TAttachmentKind read FKind write SetKind;
    property TransmittedAt: TDateTime read FTransmittedAt
      write SetTransmittedAt;
    property OnPropertyChanged: TPropertyChangedEvent read FOnPropertyChanged
      write SetOnPropertyChanged;
    property Name: string read FName write SetName;
    property Vorname: string read FVorname write SetVorname;
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Selected: Boolean read FSelected write SetSelected;
  end;

implementation

uses
  System.SysUtils, WebLib.Json, WebLib.REST, WebLib.Controls, WebLib.LocalFiles,
  UResultModel;

{ TAttachmentModel }

procedure TAttachmentModel.ClearValues;
begin
  Self.FakNr := '';
  Self.Filename := '';
  Self.CreatedAt := now;
  Self.Kind := akUnknown;
  Self.TransmittedAt := 0;
  Self.Name := '';
  Self.Vorname := '';
  Self.PersonalNr := '';
  Self.Selected := false;
end;

constructor TAttachmentModel.Create;
begin
  Self.ClearValues;
  Self.OnPropertyChanged := nil;
end;

constructor TAttachmentModel.Create(Json: string);
begin
  Self.SetValues(Json);
  Self.OnPropertyChanged := nil;
end;

procedure TAttachmentModel.DoPropertyChanged(PropertyName: string);
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self, PropertyName);
end;

procedure TAttachmentModel.SetCreatedAt(const Value: TDateTime);
begin
  FCreatedAt := Value;
  Self.DoPropertyChanged('CreatedAt');
end;

procedure TAttachmentModel.SetFakNr(const Value: string);
begin
  FFakNr := Value;
  Self.DoPropertyChanged('FakNr');
end;

procedure TAttachmentModel.SetFilename(const Value: string);
begin
  FFilename := Value;
  Self.DoPropertyChanged('Filename');
end;

procedure TAttachmentModel.SetKind(const Value: TAttachmentKind);
begin
  FKind := Value;
  Self.DoPropertyChanged('Kind');
end;

procedure TAttachmentModel.SetName(const Value: string);
begin
  FName := Value;
  Self.DoPropertyChanged('Name');
end;

procedure TAttachmentModel.SetOnPropertyChanged(const Value
  : TPropertyChangedEvent);
begin
  FOnPropertyChanged := Value;
end;

procedure TAttachmentModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
  Self.DoPropertyChanged('PersonalNr');
end;

procedure TAttachmentModel.SetSelected(const Value: Boolean);
begin
  if FSelected <> Value then
  begin
    FSelected := Value;
    Self.DoPropertyChanged('Selected');
  end;
end;

procedure TAttachmentModel.SetTransmittedAt(const Value: TDateTime);
begin
  if FTransmittedAt <> Value then
  begin
    FTransmittedAt := Value;
    Self.DoPropertyChanged('TransmittedAt');
  end;
end;

procedure TAttachmentModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['FakNr'] <> nil then
    Self.FakNr := string(obj['FakNr']);
  if obj['Filename'] <> nil then
    Self.Filename := string(obj['Filename']);
  if obj['CreatedAt'] <> nil then
    Self.CreatedAt := StrToDateTime(string(obj['CreatedAt']));
  if obj['Kind'] <> nil then
    Self.Kind := StrToAttachmentKind(string(obj['Kind']));
  if obj['TransmittedAt'] <> nil then
    Self.TransmittedAt := StrToDateTime(string(obj['TransmittedAt']));
  if obj['Name'] <> nil then
    Self.Name := string(obj['Name']);
  if obj['Vorname'] <> nil then
    Self.Vorname := string(obj['Vorname']);
  if obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(obj['PersonalNr']);
end;

procedure TAttachmentModel.SetVorname(const Value: string);
begin
  FVorname := Value;
  Self.DoPropertyChanged('Vorname');
end;

procedure TAttachmentModel.SetValues(Json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(Json);
  Self.SetValues(obj);
end;

function TAttachmentModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('FakNr', Self.FakNr);
  obj.AddPair('Filename', Self.Filename);
  obj.AddPair('CreatedAt', DateTimeToStr(Self.CreatedAt));
  obj.AddPair('Kind', AttachmentKindToStr(Self.Kind));
  obj.AddPair('TransmittedAt', DateTimeToStr(Self.TransmittedAt));
  obj.AddPair('Name', Self.Name);
  obj.AddPair('Vorname', Self.Vorname);
  obj.AddPair('PersonalNr', Self.PersonalNr);
  Result := obj.ToJson;
  obj.Free;
end;

end.
